import React from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { CardActionButton } from './cardActionButton';
import Tooltip from '@atlaskit/tooltip';
import { fireMediaCardEvent } from '../../../../utils/analytics';
export var CardActionIconButton = function CardActionIconButton(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    filename = _ref.filename,
    triggerColor = _ref.triggerColor,
    onClick = _ref.onClick,
    isPrimary = _ref.isPrimary,
    variant = _ref.variant,
    isDisabled = _ref.isDisabled,
    tooltip = _ref.tooltip;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;

  // this is to prevent currently focused text to loose cursor on clicking card action
  // this does not prevent onclick behavior
  var onMouseDown = function onMouseDown(event) {
    event.preventDefault();
  };
  var handleClick = function handleClick(e) {
    var actionSubjectId = isPrimary ? 'mediaCardPrimaryActionButton' : 'mediaCardSecondaryActionButton';
    fireMediaCardEvent({
      eventType: 'ui',
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: actionSubjectId,
      attributes: {
        label: label
      }
    }, createAnalyticsEvent);
    onClick === null || onClick === void 0 || onClick(e);
  };
  var cardActionButton = /*#__PURE__*/React.createElement(CardActionButton, {
    onClick: handleClick,
    onMouseDown: onMouseDown
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: {
      color: triggerColor
    },
    label: filename ? "".concat(filename, " \u2014 ").concat(label) : label,
    variant: variant,
    disabled: isDisabled
  }, icon);
  return tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltip,
    position: "bottom",
    tag: "span"
  }, cardActionButton) : cardActionButton;
};